export enum PaymentMethod {
  CC = 'CC',
  EFT = 'EFT',
}
